import React, { forwardRef } from 'react'
import clsx from 'clsx'

import styles from './Menu.module.scss'

interface MenuItemProps {
  children?: React.ReactNode
  className?: string
  icon?: React.ReactNode
  active?: boolean
  isFirstChild?: boolean
}

export const MenuItem = forwardRef<HTMLLIElement, MenuItemProps>(
  ({ children, className, icon, active, isFirstChild, ...props }, ref) => {
    return (
      <li
        {...props}
        ref={ref}
        className={clsx(styles['hds-menu__dropdown-item'], className, { active })}
      >
        {children}
      </li>
    )
  }
)
